import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";

export const listStyles = style({
  display: "flex",
  flex: 1,
  justifyContent: "center",
  gap: vars.space["2xs"],
});

const chipCardLinkBase = style({
  all: "unset",
  flex: 1,
  cursor: "pointer",
});

export const chipCardLink = styleVariants({
  default: [chipCardLinkBase],
  responsive: [
    chipCardLinkBase,
    {
      "@media": {
        [`screen and (min-width:${breakpoints[1]})`]: {
          flex: "0 1 25%",
        },
      },
    },
  ],
});
